module.exports = __webpack_public_path__ + "img/drag_mock.d0333621.svg";